import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { AppComponent } from 'src/app/app.component';
import {
  AlertService,
  AuthenticationService,
  EncrDecrService,
} from 'src/app/_services';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { RequestLogin3plapp, Wms } from 'src/app/_models';
@Component({
  selector: 'app-login-app',
  templateUrl: './login-app.component.html',
  styleUrls: ['./login-app.component.css']
})
export class LoginAppComponent implements OnInit {
  loginForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  RequestLogin3plapp:Wms;
  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private alertService: AlertService,
    private menu: AppComponent,
    private EncrDecr: EncrDecrService,
    private http: HttpClient
  ) {
    if (this.authenticationService.currentUserValue) {
      this.OnLoginAuto();
      //this.router.navigate(['/']);
    } else {
      this.OnLoginAuto();
    }
  }

  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
    });
    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }
  // convenience getter for easy access to form fields
  get f() {
    return this.loginForm.controls;
  }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    }
    try {
      this.loading = true;
      this.authenticationService
        .login(this.f.username.value, this.f.password.value)
        .pipe(first())
        .subscribe(
          (data) => {
            try {
              if (data.rol != null) {
                try {
                  var CompanyID = data.companyIdWh;
                  var ClientAccNum = data.customerId;
                  var UserName = data.name;
                  var UserID = data.whId;
                  var AppTheme = '';
                  var ul = '';

                  if (ClientAccNum == '') {
                    ul +=
                      environment.apiComplement +
                      '/LoginWerehouse.aspx?CompanyID=' +
                      CompanyID +
                      '&UserName=' +
                      UserName +
                      '&UserID=' +
                      UserID +
                      '&AppTheme=https://cdn.3plfreightsoftware.com/cdn/css/Start/jqueryuimaster.min.css';
                  } else {
                    ul +=
                      environment.apiComplement +
                      '/LoginWerehouse.aspx?CompanyID=' +
                      CompanyID +
                      '&UserName=' +
                      UserName +
                      '&UserID=' +
                      UserID +
                      '&AppTheme=https://cdn.3plfreightsoftware.com/cdn/css/Start/jqueryuimaster.min.css&ClientAccNum=' +
                      ClientAccNum;
                  }

                  window.open(ul);
                } catch (error) {}
                if (data.rol == 'AdministradorEmpresa') {
                  this.authenticationService
                    .Signallogin(this.f.username.value, this.f.password.value)
                    .pipe(first())
                    .subscribe(
                      (data) => {
                        this.router.navigate([this.returnUrl]);
                      },
                      (error) => {
                        this.alertService.error(error);
                        this.loading = false;
                      }
                    );
                } else {
                  this.router.navigate([this.returnUrl]);
                }
              } else {
                Swal.fire(
                  'System',
                  'Your username or password are incorrect, please check your access data',
                  'error'
                );
                localStorage.clear();
                this.router.navigate(['/login']);
              }
            } catch (error) {
              Swal.fire(
                'System',
                'Your username or password are incorrect, please check your access data',
                'error'
              );
              localStorage.clear();
              this.router.navigate(['/login']);
            }
          },
          (error) => {
            Swal.fire(
              'System',
              'Your username or password are incorrect, please check your access data',
              'error'
            );
            localStorage.clear();
            this.router.navigate(['/login']);
            this.alertService.error(error);
            this.loading = false;
          }
        );
    } catch (error) {
      Swal.fire(
        'System',
        'Your username or password are incorrect, please check your access data',
        'error'
      );
      localStorage.clear();
      this.router.navigate(['/login']);
    }
  }
  OnLoginAuto() {
    try {
      /* var user = localStorage.getItem('LogAut');

      if (user != null) {
        var users = localStorage.getItem('LogAutUs');
        var pass = localStorage.getItem('LogAutPas');
        var decrypted = this.EncrDecr.get('3PLsofwareTeam$#@$^@1ERF', users);
        var decrypted2 = this.EncrDecr.get('3PLsofwareTeam$#@$^@1ERF', pass);
        try {
          this.authenticationService
            .login(decrypted, decrypted2)
            .pipe(first())
            .subscribe(
              (data) => {
                try {
                  if (data.rol != null) {
                    try {
                      var CompanyID = data.companyIdWh;
                      var ClientAccNum = data.customerId;
                      var UserName = data.name;
                      var UserID = data.whId;
                      var AppTheme = '';
                      var ul = '';

                      if (ClientAccNum == '') {
                        ul +=
                          environment.apiComplement +
                          '/LoginWerehouse.aspx?CompanyID=' +
                          CompanyID +
                          '&UserName=' +
                          UserName +
                          '&UserID=' +
                          UserID +
                          '&AppTheme=https://cdn.3plfreightsoftware.com/cdn/css/Start/jqueryuimaster.min.css';
                      } else {
                        ul +=
                          environment.apiComplement +
                          '/LoginWerehouse.aspx?CompanyID=' +
                          CompanyID +
                          '&UserName=' +
                          UserName +
                          '&UserID=' +
                          UserID +
                          '&AppTheme=https://cdn.3plfreightsoftware.com/cdn/css/Start/jqueryuimaster.min.css&ClientAccNum=' +
                          ClientAccNum;
                      }

                      window.open(ul);
                    } catch (error) {}
                    this.authenticationService
                      .Signallogin(decrypted, decrypted2)
                      .pipe(first())
                      .subscribe(
                        (data) => {
                          this.router.navigate(['/']);
                        },
                        (error) => {
                          localStorage.clear();
                          this.router.navigate(['/login']);
                          this.alertService.error(error);
                          this.loading = false;
                        }
                      );
                  } else {
                    localStorage.clear();
                    this.router.navigate(['/login']);
                  }
                } catch (error) {
                  localStorage.clear();
                  this.router.navigate(['/login']);
                }
              },
              (error) => {
                localStorage.clear();
                this.router.navigate(['/login']);
                this.alertService.error(error);
                this.loading = false;
              }
            );
        } catch (error) {
          localStorage.clear();
          this.router.navigate(['/login']);
        }
      } else {
        var usse = this.route.snapshot.queryParams['LoUss'];
        var ussePas = this.route.snapshot.queryParams['LoUssPass'];

        if (usse != undefined && ussePas != undefined) {
          var decrypted = this.EncrDecr.get(
            '3PLsofwareTeam$#@$^@1ERF',
            decodeURIComponent(usse)
          );
          var decrypted2 = this.EncrDecr.get(
            '3PLsofwareTeam$#@$^@1ERF',
            decodeURIComponent(ussePas)
          );
          this.authenticationService
            .login(decrypted, decrypted2)
            .pipe(first())
            .subscribe(
              (data) => {
                this.authenticationService
                  .Signallogin(decrypted, decrypted2)
                  .pipe(first())
                  .subscribe(
                    (data) => {
                      this.router.navigate(['/']);
                    },
                    (error) => {
                      this.alertService.error(error);
                      this.loading = false;
                    }
                  );
              },
              (error) => {
                this.alertService.error(error);
                this.loading = false;
              }
            );
        } else {
          //login app.3pl
         
        }
      } */
   
   
      var app3pl = this.route.snapshot.queryParams['enckey'];

      if (app3pl != null) {
        var auth = atob(app3pl);
        this.RequestLogin3plapp = JSON.parse(auth);
        localStorage.clear();

localStorage.setItem("dataLogin",JSON.stringify(this.RequestLogin3plapp))
        this.authenticationService
          .login3plapp(this.RequestLogin3plapp.id,this.RequestLogin3plapp.whId,this.RequestLogin3plapp.useremail,this.RequestLogin3plapp.token)
          .pipe(first())
          .subscribe(
            (data) => {
              this.router.navigate(['/']);
            },
            (error) => {
              this.alertService.error(error);
              this.loading = false;
            }
          );
      }
   
   
   
   
   
   
    } catch (error) {}
  }
}